import { removeFromArray } from '@standardnotes/utils';
import { AbstractService } from '../Service/AbstractService';
import { StatusServiceEvent } from './StatusServiceInterface';
/* istanbul ignore file */
export class StatusService extends AbstractService {
    constructor() {
        super(...arguments);
        this.preferencesBubbleCounts = {
            general: 0,
            account: 0,
            security: 0,
            'home-server': 0,
            vaults: 0,
            appearance: 0,
            backups: 0,
            listed: 0,
            shortcuts: 0,
            plugins: 0,
            accessibility: 0,
            'get-free-month': 0,
            'help-feedback': 0,
            'whats-new': 0,
        };
        this._message = '';
        this.dynamicMessages = [];
    }
    getPreferencesBubbleCount(preferencePaneId) {
        return this.preferencesBubbleCounts[preferencePaneId];
    }
    setPreferencesBubbleCount(preferencePaneId, count) {
        this.preferencesBubbleCounts[preferencePaneId] = count;
        const totalCount = this.totalPreferencesBubbleCount;
        void this.notifyEvent(StatusServiceEvent.PreferencesBubbleCountChanged, totalCount > 0 ? totalCount.toString() : undefined);
    }
    get totalPreferencesBubbleCount() {
        return Object.values(this.preferencesBubbleCounts).reduce((total, count) => total + count, 0);
    }
    get message() {
        return this._message;
    }
    setMessage(message) {
        this.directSetMessage = message;
        this.recomputeMessage();
    }
    addMessage(message) {
        this.dynamicMessages.push(message);
        this.recomputeMessage();
        return message;
    }
    removeMessage(message) {
        removeFromArray(this.dynamicMessages, message);
        this.recomputeMessage();
    }
    recomputeMessage() {
        const messages = [...this.dynamicMessages];
        if (this.directSetMessage) {
            messages.unshift(this.directSetMessage);
        }
        this._message = this.messageFromArray(messages);
        void this.notifyEvent(StatusServiceEvent.MessageChanged, this._message);
    }
    messageFromArray(messages) {
        let message = '';
        messages.forEach((value, index) => {
            const isLast = index === messages.length - 1;
            message += value;
            if (!isLast) {
                message += ', ';
            }
        });
        return message;
    }
}
